import { DateTime } from 'luxon';

import { START_HOUR } from '../constants';

const tagMap = {
  'logistics': 0,
  'lightning_challenge': 2,
  'activities': 2,
  'food': 1,
  'judging': 0,
  'workshop': 3,
  'talk': 4
};
const transformSchedule = (data) => {
  let schedule = [{
    name: "Main Events",
    color: "#16AFFB",
    items: []
  }, {
    name: "Food",
    color: "#83C400",
    items: []
  }, {
    name: "Activities",
    color: "#E03E59",
    items: []
  }, {
    name: "Workshops",
    color: "#15CFB0",
    items: []
  }, {
    name: "Tech Talks",
    color: "#BD63CF",
    items: []
  }];
  for (var i = 0; i < data.length; i++) {
    const item = data[i];
    const cat = item.tags.reduce(function(v, tag){ // take largest tag value (since everything has logistics...)
      if (tagMap[tag] !== undefined) {
        v = Math.max(v, tagMap[tag]);
      }
      return v;
    }, -1);
    if (cat != -1) { // this fits somewhere!
      schedule[cat].items.push({
        name: item.title,
        location: item.location,
        // convert to EST
        start: DateTime.fromJSDate(item.startTime).setZone('America/New_York'),
        end: DateTime.fromJSDate(item.endTime).setZone('America/New_York'),
        description: item.description,
        category: schedule[cat].name
      });
    }
  }

  const dayMap = ['Friday', 'Saturday', 'Sunday'];

  schedule = schedule.map(function(cat) { // sort subitems and create serialized time hashes
    cat.items = cat.items.map(function(item) {
      const startDay = item.start.day,
            startHour = item.start.hour,
            startMinute = item.start.minute,
            endDay = item.end.day,
            endHour = item.end.hour,
            endMinute = item.end.minute;
      const startDate = 14;
      // subtract 18 to make 0th hour "6pm"
      item.absStartHour = (startDay - startDate) * 24 + startHour + (startMinute / 60) - START_HOUR;
      item.absEndHour = (endDay - startDate) * 24 + endHour + (endMinute / 60) - START_HOUR;
      item.startTime = (startHour % 12 || 12) + ":" + ("0" + startMinute).slice(-2);
      item.endTime = (endHour % 12 || 12) + ":" + ("0" + endMinute).slice(-2);
      item.startDate = dayMap[startDay - startDate] + ' ' + item.startTime + (startHour >= 12 ? 'pm' : 'am');
      item.endDate = dayMap[endDay - startDate] + ' ' + item.endTime + (endHour >= 12 ? 'pm' : 'am');
      item.color = cat.color;
      return item;
    });
    cat.items.sort(function(a, b) {
      return a.absStartHour - b.absStartHour;
    });
    return cat;
  });
  return schedule;
};
export default transformSchedule;


// WEBPACK FOOTER //
// ./src/components/Schedule/ScheduleComponent/helpers/fetchSchedule/transformSchedule.js